// React
import type { PropsWithChildren } from "react"

// Components
import { styles as stylePdf } from "components"

// Third-Party Libraries
import moment from "moment"
import { Document, Page, Text, View } from "@react-pdf/renderer"
import { jwtDecode } from "jwt-decode"

// Types
import type { LinkAccountType, ListType } from "../types"

// Utils
import { convertNumber } from "utils"

export function PdfLinkAccount(props: {
    coa: ListType,
    dataList: LinkAccountType[],
    title: string
}): JSX.Element {
    // Vars
    const date: string = moment().format("DD MMM YYYY")
    const header = ["COMPONENT CODE", "COMPONENT NAME", "DESCRIPTION", "NUMBER", "COA NAME", "BALANCE"]
    const userData: { company_name?: string } = jwtDecode(localStorage.getItem("token") ?? "")
    const { title } = props

    return (
        <Document>
            <Page size="A4" style={stylePdf.page}>
                <View
                    fixed
                    style={stylePdf.fixedTop}
                >
                    <Text style={stylePdf.title}>{title}</Text>
                    <Text style={stylePdf.date}>{userData.company_name}</Text>
                    <Text style={stylePdf.date}>Date: {date}</Text>
                </View>

                <View style={stylePdf.table}>
                    {/* Header */}
                    <View style={stylePdf.tableHeader}>
                        {header.map((col, index) => (
                            <View style={stylePdf.tableCol}>
                                <Text
                                    style={[
                                        stylePdf.headerText,
                                        { fontSize: 9 }
                                    ]}
                                    key={index}
                                >
                                    {col}
                                </Text>
                            </View>
                        ))}
                    </View>

                    {/* Data */}
                    {props.dataList.map((sub, index) => (
                        <View
                            key={index}
                            style={stylePdf.tableRow}
                            wrap={false}
                        >
                            <Row>{sub.dashboard_link_code}</Row>
                            <Row>{sub.dashboard_link_name}</Row>
                            <Row>{sub.description}</Row>
                            <Row>{sub.datacoa.map((item, key) => <Text key={key}>{item.coa_code}</Text>)}</Row>
                            <Row>{sub.datacoa.map((item, key) => <Text key={key}>{item.coa_name}</Text>)}</Row>
                            <Row>{sub.datacoa.map((item, key) => <Text key={key}>{convertNumber(props.coa.getOpeningBalance(item.coa_id)).intoCurrency}</Text>)}</Row>
                        </View>
                    ))}
                </View>

                <View
                    fixed
                    style={stylePdf.fixed}
                >
                    <Text style={stylePdf.text}>{title} | {userData.company_name ?? "-"} | {date}</Text>

                    <Text
                        style={stylePdf.text}
                        render={({ pageNumber, totalPages }) => `Page ${pageNumber} of ${totalPages}`}
                    />
                </View>
            </Page>
        </Document>
    )
}

function Row(params: PropsWithChildren<{}>): JSX.Element {
    return (
        <View style={stylePdf.tableCol}>
            <Text style={[stylePdf.tableCell, { fontSize: 8 }]}>
                {params.children}
            </Text>
        </View>
    )
}